import { get } from "./AXIOS"
import { SEARCH_AUDITS } from "./CONSTANTS"
import {buildQueryParams} from "../helpers/utlities";

export const searchAudits = (query) => {
  const params = buildQueryParams({
    limit: query.limit,
    skip: query.offset,
    activity: query.searchTerm,
    user_id: query.user ? Number(query.user) : undefined,
  })
  return get(`${SEARCH_AUDITS}?${params.toString()}`);
}
